import ReactTable from 'react-table';
export default ReactTable.defaultProps.TrComponent;